<template>
    <el-dialog title="出版物料预览" :visible.sync="dialogVisible" width="80%" center append-to-body>
        <div class="main-demand">
            <div class="form-demand">
                <el-form ref="form" :model="ruleForm" label-width="80px">
                    <div class="form-header">
                        <div class="form-nav">
                            <el-checkbox-group v-model="selected">
                                <template v-for="(item,index) in tree">
                                    <el-checkbox-button v-if="item.id != 1" class="check-item" name="type"
                                        :label="item.id+''" :key="index" @click.native.prevent>
                                        <span>{{ item.title }}</span>
                                    </el-checkbox-button>
                                </template>
                            </el-checkbox-group>
                        </div>
                        <div class="form-submit" v-if="selected.length>0">
                            <el-date-picker class="attr-date mr8" value-format="yyyy-MM-dd" disabled
                                v-model="ruleForm.date" type="date" placeholder="进场时间"></el-date-picker>
                            <el-button type="primary" v-preventReClick @click="submit">提交</el-button>
                        </div>
                    </div>
                    <!-- @click="submit" -->
                    <div class="selected-list">
                        <template v-for="item in tree">
                            <div class="selected-item" :key="item.id" v-if="selected.includes(item.id+'')">
                                <div class="tree-title">{{item.title}}</div>
                                <div class="children">
                                    <template v-for="child in item.children">
                                        <div class="category-item" :key="child.id" v-if="forms['category_'+child.id]">
                                            <div class="category-title">
                                                {{child.title}}
                                            </div>
                                            <div class="category-rules">
                                                <div class="select-item-list">
                                                    <div class="hs-table-pro">
                                                        <div class="hs-table-row  hs-table-header">
                                                            <div class="hs-table-col">供应商</div>
                                                            <div class="hs-table-col">产品</div>
                                                            <div class="hs-table-col">价格</div>
                                                            <div class="hs-table-col" v-for="(e,v) in child.rules"
                                                                :key="v">
                                                                {{e.label}}
                                                            </div>
                                                            <div class="hs-table-col">数量</div>
                                                            <div class="hs-table-col">自定义价格</div>
                                                            <div class="hs-table-col">使用备注</div>
                                                            <div class="hs-table-col">是否作废</div>
                                                        </div>
                                                        <div class="hs-table-row"
                                                            v-for="(row,index) in forms['category_'+child.id]"
                                                            :key="index">
                                                            <div class="hs-table-col">
                                                                {{row.supplier ? row.supplier.title : '未分配'}}
                                                            </div>
                                                            <div class="hs-table-col">
                                                                {{row.product ? row.product.title : '未分配'}}
                                                            </div>
                                                            <div class="hs-table-col">
                                                                {{row.product ? row.product.price : '未分配'}}
                                                            </div>
                                                            <template v-for="(e, f) in row">
                                                                <div class="hs-table-col" :key="f"
                                                                    v-if="f!='invalid' &&f!='invalid_id' &&f!='count'&& f!='settle' && f!='remark'&& f!='supplier'&& f!='price' && f!='product'&&f!='product_id' && f!='supplier_id'">
                                                                    {{former.getRuleLabel(e,f,child.rules)}}
                                                                </div>
                                                            </template>
                                                            <div class="hs-table-col">{{row.count}}</div>
                                                            <div class="hs-table-col">{{row.price}}</div>
                                                            <div class="hs-table-col">{{row.remark}}</div>
                                                            <div class="hs-table-col">
                                                                <template v-if="row.invalid_id=='0'">已作废</template>
                                                                <template v-if="row.invalid_id=='1'"></template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </el-form>
            </div>

        </div>
    </el-dialog>
</template>

<script>
    const ruleForm = {
        count: '',
        date: ''
    };

    import {
        showDrawerPass,
    } from '@/utils/common.js';
import { preventReClick } from '@/utils/preventReClick';
    import former from '@/utils/former.js';
    import weddingUtils from '@/utils/wedding.js';
    export default {
        components: {

        },
        props: {
            parent: {},
            orderType: ''
        },
        data() {
            return {
                order_id: '',
                activeName: 'demand',
                ruleForm: Object.assign({}, ruleForm),
                category: [],
                activeNames: ['1'],
                categoryType: [],
                parent_id: 0,
                tree: [],
                selected: [],
                forms: {},
                module: 'wedding_demand',
                module_id: 0,
                dialogVisible: false,
                demand: {},
                type: ''
            }
        },
        beforeCreate() {
            this.showDrawerPass = showDrawerPass;
            this.former = former;
            this.getRuleTag = weddingUtils.getRuleTag;
        },
        methods: {
            getData(selected, demand, tree, formsAddons, use_date, type) {
                let _this = this;
                _this.dialogVisible = true;
                _this.demand = demand;
                _this.tree = tree;
                _this.selected = selected;
                _this.ruleForm.date = use_date;
                _this.type = type;
                let addons = formsAddons;

                // 过滤
                let newAddons = {};
                for (let i in addons) {
                    if (addons[i].length > 0) {
                        newAddons[i] = addons[i];
                    }
                }
                _this.forms = newAddons;
            },
            submit() {
                let _this = this;
              if (Object.keys(_this.forms).length==0) {
                this.$message({
                    type: "error",
                    message: "请录入要选择的数据并且添加"
                });
                return false;
            }
this.$confirm('确定出版物料, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
                if (_this.type == 'editors') {
                    let url = '/api/wedding.demand/update';
                    let options = {};
                    options.order_id = _this.demand.order_id;
                    options.category_parent_ids1 = _this.selected;
                    options.use_date = _this.ruleForm.date;
                    options.id = _this.demand.id;
                    options.parent_id = _this.demand.parent_id;
                    options.type = 'design_project_background';
                    options.addons1 = Object.assign({}, _this.forms);
                    this.$post(url, options).then(res => {
                        if (res.code == '200') {
                            _this.visible = false;
                            _this.$message({
                                type: 'success',
                                message: res.msg
                            });
                            if (_this.orderType == 'order') {
                                _this.parent.parent.getData(options.order_id)
                                _this.dialogVisible = false;
                                _this.parent.visible = false
                            } else {
                                _this.parent.parent.showDrawer(options)
                                _this.dialogVisible = false;
                                _this.parent.visible = false
                            }

                        } else {
                            _this.$message({
                                type: 'danger',
                                message: res.msg
                            });
                        }
                    });
                } else {
                    let url = '/api/wedding.design/create';
                    let options = {};
                    options.order_id = _this.demand.order_id;
                    options.category_parent_ids1 = _this.selected;
                    options.use_date = _this.ruleForm.date;
                    if (_this.type == 'add') {
                        options.parent_id = _this.demand.id;
                    } else {
                        options.id = _this.demand.id;
                        options.parent_id = _this.demand.parent_id;
                    }
                    options.type = 'design_project';
                    options.addons1 = Object.assign({}, _this.forms);
                    this.$post(url, options).then(res => {
                        if (res.code == '200') {
                            _this.visible = false;
                            _this.$message({
                                type: 'success',
                                message: res.msg
                            });
                            if (_this.orderType == 'order') {
                                _this.parent.parent.getData(options.order_id)
                                _this.dialogVisible = false;
                                _this.parent.visible = false
                            } else {
                                _this.parent.parent.showDrawer(options)
                                _this.dialogVisible = false;
                                _this.parent.visible = false
                            }

                        } else {
                            _this.$message({
                                type: 'danger',
                                message: res.msg
                            });
                        }
                    });
                }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });


            }
        }
    }
</script>

<style lang="less" scoped>
    @import url('@/assets/css/common.less');

    .selected-list {
        padding-left: 12px;
    }

    .selected-item {
        position: relative;
        cursor: pointer;

        .tree-title {
            padding: 8px;
            font-size: 14px;
            font-weight: 600;
        }

        .category-item {
            display: flex;
            border-top: 1px solid #dedede;

            .category-title {
                display: flex;
                width: 5rem;
                padding: 8px;
                align-items: center;
            }

            .category-rules {
                flex: 1;
                border-left: 1px solid #dedede;

                .category-item-form {
                    padding: 8px;
                    display: flex;

                    .attr-date,
                    .attr-select,
                    .attr-textarea {
                        margin-right: 5px;
                        max-width: 120px;
                    }

                    .attr-input {
                        margin-right: 5px;
                        max-width: 120px;
                        min-width: 80px;
                    }

                    .attr-count {
                        margin-right: 5px;
                        width: 7rem;
                    }

                    .attr-remark {
                        margin-right: 5px;
                        flex: 1;
                    }
                }
            }
        }

        .category-item:last-child {
            border-bottom: 1px solid #dedede;
        }

    }

    .selected-item:last-child {
        border-bottom: none;
    }

    /*** --------------------------------------- 分界线 ------------------------ ***/
    .form-header {
        display: flex;
        padding: 12px;
        border-bottom: 1px solid #dedede;

        .form-submit {
            flex: 1;
            text-align: right;
        }
    }

    .main-demand {
        display: flex;
        overflow: auto;

        .form-demand {
            flex: 1;
            padding-bottom: 20px;
        }

        .more-demand {
            flex: 0 25%;
            padding: 12px;
            border-left: 1px solid #dedede;
        }
    }

    .hs-table-pro {
        .hs-table-row {
            display: flex;
            border-top: .5px solid #f6f7fb;

            .hs-table-col {
                flex: 1;
                padding: 5px 8px;
                border-right: .5px solid #f6f7fb;
            }

            .hs-table-col.w80 {
                flex: 0 80px;
            }
        }

        .hs-table-row.hs-table-header {
            background: #f6f7fb;
            border-top: none;
        }
    }
</style>